export const nations = [
  { field: 'UK', name: 'Westminster and UK-wide' },
  { field: 'Scotland', name: 'Scotland' },
  { field: 'Wales', name: 'Wales' },
  { field: 'NorthernIreland', name: 'Northern Ireland' },
];

export const allNationFields = nations.map((nation) => nation.field);

export const parseSelectedNations = (mySelectedCountries?: string | null) => {
  const fields = mySelectedCountries?.split(',').map((field) => field.trim()) ?? [];
  const knownFields = allNationFields.filter((field) => fields.includes(field));
  return knownFields.length === 0 || fields.some((field) => field.startsWith('AllCountries'))
    ? allNationFields
    : knownFields;
};

export const isAllNations = (selectedNations: string[]) =>
  allNationFields.every((field) => selectedNations.includes(field));

export const getNationsText = (selectedNations: string[]) => {
  const selected = nations.filter(({ field }) => selectedNations.includes(field));
  const names = selected.map(({ name }) => name);
  if (names.length === nations.length) return 'all nations';
  if (names.length === 1) return `${names[0]} ${selected[0].field === 'UK' ? 'updates' : 'only'}`;
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
};
